import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';

import MenuItem from '~/components/core/Atomic/MenuItem';
import SingleSelectField from '~/components/core/Molecules/Fields/SingleSelectField';
import { getPopoverTriggerAria } from '~/components/ui/atoms/Popover/usePopoverState';

import CardDialog from '../../CardDialog';
import { Text } from '../../core';
import HoverActionField from '../../HoverActionField';
import useDataFetcher from '../../useDataFetcher';

function OrganizationAdjusterSelect({ organization, id, label, adjuster, onSelectAdjuster, hideLabel, showOnly }) {
  const { isLoading, data: possibleAdjusters } = useDataFetcher(
    `/sysconfig/api/v1/organizations/${organization.id}/possible_adjusters`
  );
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(undefined);
  const popoverId = useId();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <>
      <HoverActionField
        onAction={(e) => setPopoverAnchorEl(e.currentTarget)}
        actionTriggerAria={getPopoverTriggerAria(Boolean(popoverAnchorEl), popoverId)}
        disabled={showOnly}
      >
        {!hideLabel && <Text variant={Text.VARIANTS.SM}>{label}</Text>}
        {adjuster && adjuster.username}
      </HoverActionField>

      <CardDialog
        isPopover
        open={Boolean(popoverAnchorEl)}
        anchorEl={popoverAnchorEl}
        id={popoverId}
        title={`Select ${label}`}
        onClose={() => setPopoverAnchorEl(undefined)}
      >
        <SingleSelectField
          id={id}
          label={label}
          value={adjuster ? adjuster.id : 0}
          onChange={async (value) => {
            setIsSubmitting(true);
            try {
              await onSelectAdjuster(value);
              setPopoverAnchorEl(undefined);
            } catch {
              // onSelectAdjuster reports the failure. Leaving the popover open lets the choice be
              // retried rather than showing an adjuster that was never stored, and the finally is
              // what re-enables the select either way.
            } finally {
              setIsSubmitting(false);
            }
          }}
          style={{ width: 200 }}
          disabled={isLoading || isSubmitting}
        >
          {possibleAdjusters &&
            possibleAdjusters.map((adjuster) => (
              <MenuItem key={adjuster.id} value={adjuster.id}>
                {adjuster.username}
              </MenuItem>
            ))}
        </SingleSelectField>
      </CardDialog>
    </>
  );
}

OrganizationAdjusterSelect.propTypes = {
  organization: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  adjuster: PropTypes.object,
  onSelectAdjuster: PropTypes.func.isRequired,
  showOnly: PropTypes.bool,
};

export default OrganizationAdjusterSelect;
